import { createCrudSlice } from "./createCrudSlice";
import {
  GET_POS_TRANSACTIONS,
  GET_POS_TRANSACTION_DETAILS,
} from "helpers/url_helper";

const posTransactionsSlice = createCrudSlice({
  name: "posTransactions",
  urls: {
    getList: GET_POS_TRANSACTIONS,
    getDetails: GET_POS_TRANSACTION_DETAILS,
  },
  initialFilters: {},
});

// Export actions
export const { setFilter, resetFilters, clearItemDetails } =
  posTransactionsSlice.actions;

// Export thunks
export const {
  getList: getPosTransactionsList,
  getDetails: getPosTransactionDetails,
} = posTransactionsSlice.thunks;

// Export reducer
export default posTransactionsSlice.reducer;
